import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { useCases, useCasesSection } from '../data/content';
export function UseCases() {
  return <section aria-labelledby="use-cases-heading" className="w-full bg-ivory px-5 py-14 md:px-8 md:py-24" data-id="element-187" data-mp="35gys9w6dzswd">
      <div className="mx-auto w-full max-w-content" data-id="element-188" data-mp="31ek7h6j5qj2g">
        <Reveal data-id="element-189" data-mp="31dsl8mbg9xou">
          <SectionHeading id="use-cases-heading" title={useCasesSection.title} data-id="element-190" data-mp="2wg8z708iggmc" />
        </Reveal>

        <ul className="mt-12 grid gap-5 md:mt-14 md:grid-cols-3" data-id="element-191" data-mp="2rhpais2j8qqa">
          {useCases.map((useCase, index) => <Reveal as="li" key={useCase.title} delay={index * 0.05} className="flex h-full flex-col rounded-xl border border-charcoal/10 bg-white p-7" data-id="element-192" data-mp="2mht82x9hh7cu" data-mpi={index}>
              <span aria-hidden="true" className="h-px w-10 bg-brass" data-id="element-193" data-mp="kpoivtjdco5t" />
              <h3 className="mt-5 font-serif text-[1.6rem] font-semibold leading-tight text-charcoal" data-id="element-194" data-mp="gouw53hnxfei">
                {useCase.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-charcoal/75" data-id="element-195" data-mp="2rwaccven9cj5">{useCase.text}</p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}